export const discoverOurProductsMenu = {
    "Main Dish": [
        {
            imgPath: "assets/images/food/dish-3.jpg.webp",
            name: "grilled beef",
            desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
            id: "dish3",
            price: "$2.90"
        },
        {
            imgPath: "assets/images/food/dish-4.jpg.webp",
            name: "grilled beef",
            id: "dish4",
            desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia.",
            price: "$2.90"
        },
        {
            name: "Sea Trout",
            price: "$49.91",
            desc: "A small river named Duden flows by their place and supplies",
            id: "dish5",
            imgPath: "assets/images/food/dish-5.jpg.webp"
        },
        {
            name: "Roasted Beef",
            price: "$20.00",
            id: "dish6",
            desc: "A small river named Duden flows by their place and supplies",
            imgPath: "assets/images/food/dish-6.jpg.webp"
        },
        {
            name: "Butter Fried Chicken",
            price: "$20.00",
            id: "dish7",
            desc: "A small river named Duden flows by their place and supplies",
            imgPath: "assets/images/food/dish-7.jpg.webp"
        },
        {
            name: "Chiken Filet",
            price: "$20.00",
            id: "dish8",
            desc: "A small river named Duden flows by their place and supplies",
            imgPath: "assets/images/food/dish-8.jpg.webp"
        },
    ],
    Drinks: [
        {
            imgPath: "assets/images/food/drink-2.jpg.webp",
            name: "pinapple juice",
            desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
            id: "drink2",
            price: "$2.90"
        },
        {
            imgPath: "assets/images/food/drink-3.jpg.webp",
            name: "soda drinks",
            id: "drink3",
            desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
            price: "$2.90"
        },
        {
            name: "Sea Trout",
            price: "$49.91",
            desc: "A small river named Duden flows by their place and supplies",
            id: "drink5",
            imgPath: "assets/images/food/drink-5.jpg.webp"
        },
        {
            name: "Roasted Beef",
            price: "$20.00",
            desc: "A small river named Duden flows by their place and supplies",
            id: "drink6",
            imgPath: "assets/images/food/drink-6.jpg.webp"
        },
        {
            name: "Butter Fried Chicken",
            price: "$20.00",
            desc: "A small river named Duden flows by their place and supplies",
            id: "drink7",
            imgPath: "assets/images/food/drink-7.jpg.webp"
        },
        {
            name: "Chiken Filet",
            price: "$20.00",
            desc: "A small river named Duden flows by their place and supplies",
            id: "drink8",
            imgPath: "assets/images/food/drink-8.jpg.webp"
        },
    ],
    Desserts: [
        {
            imgPath: "assets/images/food/dessert-1.jpg.webp",
            name: "hot cake honey",
            id: "dessert1",
            desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
            price: "$2.90"
        },
        {
            imgPath: "assets/images/food/dessert-2.jpg.webp",
            id: "dessert2",
            name: "hot cake honey",
            desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
            price: "$2.90"
        },
        {
            imgPath: "assets/images/food/dessert-3.jpg.webp",
            id: "dessert3",
            name: "hot cake honey",
            desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
            price: "$2.90"
        },
        {
            imgPath: "assets/images/food/dessert-1.jpg.webp",
            name: "hot cake honey",
            desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
            id: "dessert1",
            price: "$2.90"
        },
        {
            imgPath: "assets/images/food/dessert-2.jpg.webp",
            name: "hot cake honey",
            id: "dessert1",
            desc: "far far away, behind the word mountains, far from the countries vokalia and consonantia.",
            price: "$2.90"
        },
    ]
}
